<template>
<div>
  <div :class="frameClasses">
    <fragment v-if="hasNoStepperStep">
      <div class="timeline-item-title">{{ name }}</div>
    </fragment>
    <fragment v-if="isFulfilled && !hasNoStepperStep">
      <div class="timeline-item-title">{{ name }}</div>
      <div class="timeline-item-date">{{ time }} hora(s)</div>
      <div class="timeline-item-vertical-line"></div>
      <div
	class="timeline-item-horizontal-line"
	:class="lineClasses"
	/>
      <div :class="checkClasses">
	<v-icon>{{ icon }}</v-icon>
      </div>
    </fragment>
    <fragment v-if="!isFulfilled && !hasNoStepperStep">
      <div class="timeline-item-title">{{ name }}</div>
      <div class="timeline-item-date">&nbsp;</div>
      <div class="timeline-item-vertical-line" />
      <div
	class="timeline-item-horizontal-line"
	:class="lineClasses"
	/>
      <div class="timeline-item-check not-arrived">
	<v-icon>check</v-icon>
      </div>
    </fragment>
  </div>
</div>
</template>

<style lang="scss" scoped>
#jns {
  .no-stepper-step {
    .timeline-item-title {
      top: 60px !important;
      position: relative;
    }
  }
  .timeline-item-title {
    color: #061d45;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .timeline-item-date {
    text-align: center;
    font-size: 12px;
    position: relative;
    top: -40px;
  }
  .timeline-item-vertical-line {
    border-left: 1px solid #d8d8d8;
    height: 17px;
    position: absolute;
    left: 50%;
    bottom: 14px;
  }
  .timeline-item-check {
    background-color: #7ed321;
    height: 30px;
    width: 30px;
    border-radius: 20px;
    margin-left: calc(50% - 15px);
    bottom: -18px;
    position: absolute;
    z-index: 3;
    i {
      font-size: 20px !important;
      color: white;
      position: absolute;
      z-index: 2;
      left: 5px;
      top: 5px;
    }

    &.late {
      background-color: #d0021b;
    }
    &.not-arrived {
      background-color: #ffffff;
      border: 1px solid #d5d5d5;
    }
    &.seguradora {
      background-color: #061d45;
    }
    &.corretor {
      background-color: #ff9700;
    }
  }
  .timeline-item-horizontal-line {
    border-top: 1px solid #d8d8d8;
    height: 1px;
    width: calc(100% + 8px);
    position: absolute;
    bottom: -4px;
    &.remove-border-left {
      width: calc(50% + 8px);
      left: 50%;
    }
    &.remove-border-right {
      width: calc(50% + 8px);
      right: 50%;
    }
  }

  .late {
    color: red;
  }
}
</style>

<script lang="js">
export default {
  name: "TimelineItemTop",
  props: [
    "time",
    "status",
    "name",
    "isFulfilled",
    "removeBorderLeft",
    "removeBorderRight",
    "hasNoStepperStep",
  ],
  computed: {
    lineClasses() {
      return {
	"remove-border-left": this.removeBorderLeft,
	"remove-border-right": this.removeBorderRight
      };
    },
    frameClasses() {
      return {
	"timeline-item-container": true,
	"no-stepper-step": this.hasNoStepperStep
      };
    },
    checkClasses() {
      const klass = {
	"verde": "",
	"vermelho": "late",
	"azul": "seguradora",
	"amarelo": "corretor"
      }[this.status];
      return {
	"timeline-item-check": true,
	[klass]: true
      };
    },
    icon() {
      return {
	"verde": "check",
	"vermelho": "warning",
	"azul": "timer",
	"amarelo": "timer"
      }[this.status];
    }
  },
  methods: {
    getHorizontalLineClasses() {
      let t = this;
      let classes = [];
      if (t.removeBorderLeft) {
        classes.push({ "remove-border-left": true });
      }
      if (t.removeBorderRight) {
        classes.push({ "remove-border-right": true });
      }
      return classes;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/components/TimelineItemTop.vue